export const columns = [
  // {
  //   title: "#",
  //   dataIndex: "index",
  //   width: 60,
  //   slots: { customRender: "index" },
  // },
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },
  {
    title: "清单编号",
    width: 180,
    key: "bizNo",
    dataIndex: "bizNo",
  },
  {
    title: "材料编号",
    width: 200,
    key: "materialNo",
    dataIndex: "materialNo",
  },
  {
    title: "材料名称",
    width: 200,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title: "品牌",
    width: 150,
    key: "materialBrand",
    dataIndex: "materialBrand",
  },
  {
    title: "规格型号",
    width: 150,
    key: "materialModel",
    dataIndex: "materialModel",
  },
  {
    title: "结算单位",
    width: 150,
    key: "materialUnit",
    dataIndex: "materialUnit",
  },
  {
    title: "数量",
    width: 150,
    key: "count",
    dataIndex: "count",
  },
  {
    title: "预算成本价(元)",
    width: 150,
    dataIndex: "costPrice",
    key: "costPrice",
    slots: { title: "costPriceTitle" },
  },
  {
    title: "市场销售价(元)",
    width: 150,
    dataIndex: "salesPrice",
    key: "salesPrice",
    slots: { title: "salesPriceTitle" },

  },
  {
    title: "单价（￥）",
    width: 150,
    key: "price",
    dataIndex: "price",
  },
  {
    title: "合价（￥）",
    width: 150,
    key: "totalPrice",
    dataIndex: "totalPrice",
  },
  {
    title: "需求日期",
    width: 150,
    key: "demandTime",
    dataIndex: "demandTime",
  },
  {
    title: "是否在合同内",
    width: 150,
    key:'isInnerContract',
    slots: { customRender: "isInnerContract" },
  },
  {
    title: "描述",
    width: 300,
    key: "remark",
    dataIndex: "remark",
  },
];
